import { AccordionItemModel } from '@_types/organisms';
import { getModifiers } from '@helpers/functions';
import Icon from '@atoms/icons/Icon';
import FigurePicture from '@atoms/pictures/FigurePicture';
import FilterCriterion from '@molecules/filter-criterion/FilterCriterion';
import ReportEditionItems from '@organisms/report-editions/ReportEditionItems';

const AccordionItem = (model: AccordionItemModel) => {
  const styleModifiers = getModifiers(model, 'kf-o-accordion-item');
  const { title, contentArea, expanded, image, filterCriterion, icon, reportEditionItems } = model;

  return (
    <div className={styleModifiers} data-expanded={expanded}>
      <div className="kf-o-accordion-item__heading">
        <h3 className="kf-o-accordion-item__heading-title">
          <button className="kf-o-accordion-item__heading-button" type="button">
            {title}
            {icon && (
              <span className="kf-o-accordion-item__heading-icon">
                <Icon {...icon} />
              </span>
            )}
          </button>
        </h3>
      </div>
      <div className="kf-o-accordion-item__inside">
        {filterCriterion && <FilterCriterion {...filterCriterion} />}
        {contentArea && <div dangerouslySetInnerHTML={{ __html: contentArea.content }} className="kf-rich-text-box" />}
        {image && (
          <div className="kf-o-accordion-item__image">
            <FigurePicture {...image} />
          </div>
        )}
        {reportEditionItems && <ReportEditionItems {...reportEditionItems} />}
      </div>
    </div>
  );
};

export default AccordionItem;
